import * as constants from './constants';

export function getCampaign() {
  return {
    type: constants.GET_CAMPAIGN_REQUEST,
    isFetching: true,
  };
}

export function getCampaignError(error) {
  return {
    type: constants.GET_CAMPAIGN_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function getCampaignSuccess(campaign) {
  return {
    type: constants.GET_CAMPAIGN_SUCCESS,
    isFetching: false,
    errorMessage: null,
    campaign,
  };
}

export function getReferralLink() {
  return {
    type: constants.GET_REFERRAL_LINK_REQUEST,
    isFetching: true,
  };
}

export function getReferralLinkError(error) {
  return {
    type: constants.GET_REFERRAL_LINK_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function getReferralLinkSuccess(link) {
  return {
    type: constants.GET_REFERRAL_LINK_SUCCESS,
    isFetching: false,
    errorMessage: null,
    link,
  };
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/actions.js